
    import { Component, Prop } from 'nuxt-property-decorator';
    import PaletteStylesMixin from '@/mixins/paletteStylesMixin';

    @Component
    export default class SliderBullets extends PaletteStylesMixin {
        @Prop() slidesAmount;
        @Prop() current;
    }
